import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge as IdIcon, CameraAlt, PhoneIphone } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { Badge, Button, PageHeader, StepActions } from "@components/ui_v2";
import { PATHS_EXPEDIENTE_V2 } from "@helpers/constantes";

const ITEMS = [
  { icon: <IdIcon fontSize="small" />, label: "Identificación oficial vigente", sub: "INE, pasaporte o cédula profesional" },
  { icon: <CameraAlt fontSize="small" />, label: "Selfie con prueba de vida", sub: "Toma una foto con buena iluminación" },
  { icon: <PhoneIphone fontSize="small" />, label: "Cámara con permisos activados", sub: "Necesitamos acceder a la cámara para la captura" },
];

export const ExpValId = () => {
  const navigate = useNavigate();
  const [valIdDone, setValIdDone] = useState(false);

  const onBack = () => navigate(PATHS_EXPEDIENTE_V2.personas.path);
  const onNext = () => navigate(PATHS_EXPEDIENTE_V2.revision.path);

  return (
  <Box>
    <PageHeader
      eyebrow="Expediente · Validación de identidad"
      title="Validemos tu identidad"
      subtitle="Realizaremos un proceso biométrico. Tendrás que tomarte una selfie y fotografiar tu identificación oficial."
    />

    <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "background.paper", borderRadius: 2, p: 3 }}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {ITEMS.map((it) => (
          <Box key={it.label} sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box sx={{ width: 36, height: 36, borderRadius: 2, bgcolor: "action.hover", display: "flex", alignItems: "center", justifyContent: "center", color: "text.secondary", flexShrink: 0 }}>
              {it.icon}
            </Box>
            <Box>
              <Typography variant="body2" fontWeight={500}>
                {it.label}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {it.sub}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>

    {valIdDone ? (
      <Box sx={{ mt: 2 }}>
        <Badge tone="ok">Identidad validada</Badge>
      </Box>
    ) : (
      <Box sx={{ mt: 2 }}>
        <Button tone="primary" onClick={() => setValIdDone(true)}>
          Iniciar validación
        </Button>
      </Box>
    )}

    <StepActions onBack={onBack} onNext={onNext} nextDisabled={!valIdDone} />
  </Box>
  );
};
